



























































































































import { defineComponent, ref, computed, Ref, PropType } from '@vue/composition-api';
import commentModel from '../commentModel';
import { useApolloModel } from 'vue-apollo-model';
import { elapsedTime } from '@/common/util/time';
import CommentInput from './comment-input.vue';
import Operation from './operation.vue';
import SubItem from './sub-item.vue';
import { CurrentUserModel } from '@/models/current-user';
import { LoginSource } from '@/common/const';
import { useSendComment, useSubCommentList, useJumpToProfile } from './utils';
import { useLog } from '@/common/log';
import { useBroadcast, transEmoji } from '@/common/utils';
import CommentContent from './comment-content/index.vue';
import { filterXss } from '@/common/util/parseText';
import SettingEntry from '@/components/business-block/setting-entry/index.vue';
import { debounce } from 'lodash';
import { Maybe, VisionSubCommentItem } from '@/generated-models';

export default defineComponent({
    props: {
        comment: {
            type: Object,
            required: true,
        },
        bufCount: {
            type: Number,
            default: 2,
        },
        currentWork: {
            type: Object,
            required: true,
        },
        currentAuthor: {
            type: Object,
            required: true,
        },
        canAddComment: {
            type: Number,
        },
        inputPlaceholder: {
            type: String,
        },
        isDark: {
            type: Boolean,
        },
        logType: {
            type: String,
        },
    },
    components: {
        Operation,
        CommentInput,
        SubItem,
        CommentContent,
        SettingEntry,
    },
    filters: {
        transEmoji,
        filterXss,
    },
    setup(props, { root, emit }) {
        const subCommentCurrentPage = ref(0);
        const subCommentsList = ref([]);
        const currentPage = computed(() => root.$route?.meta?.page);

        const reopt: Ref<InstanceType<typeof Operation> | null> = ref(null);

        const model = useApolloModel(commentModel);
        const currentUserModel = useApolloModel(CurrentUserModel);
        const showReplyInput = computed(() => props.comment?.commentId === model.replyInputId);
        const isSendingComment = ref(false);
        const log = useLog();
        const elapseTime = elapsedTime({
            begin: new Date(props.comment?.timestamp),
            end: new Date(Math.max(props.comment?.timestamp, +new Date())),
        });
        const hasMoreSubComments = computed(() => (props.comment?.subCommentsPcursor && props.comment.subCommentsPcursor !== 'no_more'));
        const allSubCommentShowed = computed(() => {
            return !hasMoreSubComments.value && subCommentsList.value.length === props.comment?.subComments?.length;
        });
        useSubCommentList(subCommentCurrentPage, subCommentsList, props.comment);
        // 不受影响
        const curCommentList = computed(() => {
            return subCommentsList.value.slice(props.bufCount || 0);
        //    return props.comment.subComments.slice(props.bufCount || 0)
        });

        function compareCount(count: number, arr: Array<Maybe<VisionSubCommentItem>>) {
            if (!count || typeof count !== 'number') {
                return (arr && arr.length) || 0;
            }
            if (!arr) {
                return count || 0;
            }

            return Math.max(count, arr.length);
        }

        // curComment代表评论不受影响
        const curCommentLength = computed(() => {
            const num = props.comment?.subCommentCount! - props.bufCount;
            const subCommentArr = props.comment?.subComments!.slice(props.bufCount ?? 0) ?? [];
            const count = compareCount(num, subCommentArr);
            return count > 0 ? count : 0;
        });
        // bufCount不受影响
        const bufCountList = computed(() => {
            if (props.bufCount === 0) {
                return [];
            }
            return props.comment?.subComments?.slice(0, props.bufCount);
        });

        const broadcast = useBroadcast();
        async function loadMoreSubComments() {
            if (hasMoreSubComments.value) {
                await model.getSubCommentList({
                    photoId: props.currentWork.id,
                    rootCommentId: props.comment?.commentId ?? '',
                    pcursor: props.comment?.subCommentsPcursor ?? '',
                });
            }

            subCommentCurrentPage.value++;
        }
        function handleLogin(loginSource: string) {
            return broadcast('login', {
                // 登录源，供日志上报使用
                source: loginSource,
            });
        }
        const sendComment = debounce(async () => {
            if (isSendingComment.value) {
                return;
            }
            isSendingComment.value = true;
            await useSendComment(model, {
                photoId: props.currentWork.id,
                photoAuthorId: props.currentAuthor.id,
                isReplyInput: true,
                replyToCommentId: props.comment?.commentId,
                userInfo: currentUserModel?.userInfo,
                expTag: props.currentWork.expTag,
            }, () => {
                if (!currentUserModel?.userInfo.id) {
                    return handleLogin(LoginSource.COMMENT);
                }
                log({
                    type: 'CLICK',
                    logType: props.logType || null,
                    event_name: 'POST_COMMENT_BUTTON',
                });
            });
            if (model.isBlockedComment) {
                emit('block-comment');
            }
            reopt.value?.restoreState();
            isSendingComment.value = false;
        }, 300);

        const isLogin = computed(() => !!currentUserModel?.userInfo.id);

        return {
            subCommentCurrentPage,
            hasMoreSubComments,
            model,
            elapseTime,
            subCommentsList,
            showReplyInput,
            allSubCommentShowed,
            loadMoreSubComments,
            currentUserModel,
            sendComment,
            useJumpToProfile,
            broadcast,
            curCommentList,
            curCommentLength,
            bufCountList,
            reopt,
            isLogin,
            currentPage,
        };
    },
});
